import { Button, Flex, Icon, Text } from "@chakra-ui/react";
import { skipToken } from "@reduxjs/toolkit/dist/query";
import { t } from "i18next";
import { useState } from "react";
import { FaArrowRight, FaFileContract } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { BseDto, ContractStateDto, ReceivedBseBidDto, useGetContractQuery } from "../../../../autogen/bff-api";
import { urls } from "../../../../urls";
import { CreateContractModal } from "./CreateContractModal";

export const CreateContractDetail = ({ bid, sourcingEvent }: { bid: ReceivedBseBidDto; sourcingEvent: BseDto }) => {
  const navigate = useNavigate();
  const [showCreateModal, setShowCreateModal] = useState(false);
  const contractId = bid.contractId;
  const { data: contract, isFetching } = useGetContractQuery(contractId ? { contractId } : skipToken);

  const goToContract = (id: string) =>
    navigate(
      contract?.state === ContractStateDto.Published
        ? urls.contracts.viewSingle.go(id)
        : urls.contracts.edit.go(id, sourcingEvent.id).review
    );

  return (
    <Flex key={bid.id} alignItems={"center"} py="4">
      <Text fontWeight={"semibold"} pr="4">
        {bid.owningOrganization.name}
      </Text>
      {contractId ? (
        <Button
          colorScheme="teal"
          variant={"ghost"}
          rightIcon={<Icon as={FaArrowRight} />}
          isLoading={isFetching}
          onClick={() => goToContract(contractId)}
        >
          {t("Go to contract")}
        </Button>
      ) : (
        <>
          <Button
            size="sm"
            variant={"outline"}
            colorScheme="teal"
            leftIcon={<Icon as={FaFileContract} />}
            onClick={() => setShowCreateModal(true)}
          >
            {t("Create contract")}
          </Button>
          {showCreateModal && (
            <CreateContractModal onClose={() => setShowCreateModal(false)} sourcingEvent={sourcingEvent} bid={bid} />
          )}
        </>
      )}
    </Flex>
  );
};
